var n;!function(n){n.LoginStateChanged="dip-login-state-changed"}(n||(n={}));const e="is-user-logged-in";export{e as LOGIN_STATE_STORAGE_KEY,n as LoginEventsEnum};
